import type { FaireProductEntity } from "../../entity_types/product";

export const p_hybf9gwsyh: FaireProductEntity = {
  token: "p_hybf9gwsyh",
  type: "product",
  name: "NEW TO THE CREW BEANIE",
  brandToken: "b_n5qta5twp3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d20aee46a30ee34890b4e707c6f34108a260c870918d7ca04ac5f29d1a21ca82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ecd6c2693eaa47f39826cf37da271f2e8634204132ccd3b73ba46553d4a86b7.jpeg",
  ],
  priceDollars: 18.02,
  description:
    "Welcome the newest member of your squad with Rad Toddler Co.'s 'New to the Crew' beanie. Crafted from soft acrylic, this trendy beanie is designed to keep your little one stylish and warm. It's suitable for kids aged 6 months to 5 years, making it a versatile addition to their wardrobe. As part of our popular bee-happy collection, this beanie continues our tradition of creating cool, trendy clothes for your little ones.",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:50.852Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
